import {useEffect} from "react";
import {useAppContext} from "../utils/AppContext";
import Hero from "../components/home/Hero";
import Demo from "../components/home/Demo";
import Pitch from "../components/home/Pitch";
import Benefits from "../components/home/Benefits";
import Steps from "../components/home/Steps";
import Offer from "../components/home/Offer";
import Faqs from "../components/home/Faqs";
import Testimonials from "../components/home/Testimonials";
import Cta from "../components/home/Cta";
import Footer from "../components/home/Footer";
import {motion} from "motion/react"

const sectionList = [
  {id: "top", component: Hero},
  {id: "demo", component: Demo},
  {id: "pitch", component: Pitch},
  {id: "benefits", component: Benefits},
  {id: "steps", component: Steps},
  {id: "offer", component: Offer},
  {id: "testimonials", component: Testimonials},
  {id: "faqs", component: Faqs},
  {id: "cta", component: Cta},
];

const Home = () => {
    const {
        screenSize,
        sectionRefs,
        setActiveSection,
        scrollContainerRef
    } = useAppContext();

    const contentContainer = (!screenSize)? "content-container" : `content-container content-container${screenSize}`;
    const contentScroll = (!screenSize)? "content-scroll" : `content-scroll content-scroll${screenSize}`;

    useEffect(() => {
        setActiveSection("top");
    }, []); // eslint-disable-line
    
    return (
        <div className={contentContainer}>
            <div 
                className={contentScroll}
                ref={scrollContainerRef}
            >
                {sectionList.map(({id, component: SectionComponent}) => (
                    <motion.div
                        key={id}
                        id={id}
                        initial={{opacity: 0}}
                        whileInView={{opacity: 1}}
                        transition={{duration: 1}}
                        ref={el => {sectionRefs.current[id] = el}}
                    >
                        <SectionComponent id={id}/>
                    </motion.div>
                ))}
                <motion.div
                    initial={{opacity: 0}}
                    whileInView={{opacity: 1}}
                    transition={{duration: 0.7}}
                >
                    <Footer/>
                </motion.div>
            </div>
        </div>
    )

}

export default Home;
